import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { LinkBoxTabs } from '@seo/linkbox';
import { useAppContext } from '../../contexts/AppContext';
export const LinkboxTestId = 'serp-linkbox-testid';
export const LinkBox = () => {
    const linkboxes = useAppContext((store) => store.linkboxes);
    return (_jsx(Box, { testId: LinkboxTestId, width: "100%", maxWidth: "1280px", marginHorizontal: "auto", paddingHorizontal: {
            'breakpoint.base': 'spacing.16',
            'breakpoint.md': 'spacing.32',
        }, children: _jsx(LinkBoxTabs, { dataTabs: linkboxes }) }));
};
